module.exports = __webpack_public_path__ + "media/images/favicon-32x32-180ee6cfea1f0605c39d006fa766d388.png";